"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getHocName;

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

function getHocName(hocComponentName, Wrapped) {
  var wrappedComponentName = Wrapped.displayName || Wrapped.name || 'Component';
  return "".concat((0, _upperFirst.default)(hocComponentName), "(").concat(wrappedComponentName, ")");
}